import { FormDatePicker, FormInput, FormWrapper } from 'components/form';
import { useTranslation } from 'react-i18next';
import { HospitalSelect } from '../components/HospitalSelect';
import ClaimCardWrapper from 'components/claimCard/ClaimCardWrapper';
import { PatientSelect } from '../components/PatientSelect';
import { DEFAULT_DATE_FORMAT } from 'utils';
import moment from 'moment-timezone';

const ClaimInfoCard = () => {
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const disabledPastDate = (current: any) => {
    return current && current <= moment().startOf('day');
  };

  return (
    <ClaimCardWrapper id="requestInformation" header="preAuthRequest.requestInformation.title" stepIndex={0}>
      <PatientSelect />

      <FormWrapper name="admissionDate" label={t('preAuthRequest.requestInformation.admissionDate.label')}>
        <FormDatePicker
          name="admissionDate"
          format={DEFAULT_DATE_FORMAT}
          disabledDate={disabledPastDate}
          placeholder={t('preAuthRequest.requestInformation.admissionDate.placeholder')}
        />
      </FormWrapper>

      <HospitalSelect />

      <FormWrapper name="doctor" label={t('preAuthRequest.requestInformation.doctor.label')}>
        <FormInput name="doctor" placeholder={t('preAuthRequest.requestInformation.doctor.placeholder')} />
      </FormWrapper>

      <FormWrapper name="diagnosis" label={t('preAuthRequest.requestInformation.diagnosis.label')}>
        <FormInput name="diagnosis" placeholder={t('preAuthRequest.requestInformation.diagnosis.placeholder')} />
      </FormWrapper>

      <FormWrapper name="surgery" label={t('preAuthRequest.requestInformation.surgery.label')}>
        <FormInput name="surgery" placeholder={t('preAuthRequest.requestInformation.surgery.placeholder')} />
      </FormWrapper>
    </ClaimCardWrapper>
  );
};

export default ClaimInfoCard;
